export const generatePhoneBookPackagesCall = `
  query getPhoneBookPackagesNumber($request: PhoneBookPackageRequest!) {
    phoneBookPackages(request: $request) {
      phoneNumber
    }
  }
`
